import React, { memo, SVGProps } from 'react'

export const StatusActive = memo((props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M12 0C5.376 0 0 5.376 0 12C0 18.624 5.376 24 12 24C18.624 24 24 18.624 24 12C24 5.376 18.624 0 12 0ZM17.8347 9.07733L10.8693 16.0427C10.72 16.192 10.5173 16.2773 10.304 16.2773C10.0907 16.2773 9.888 16.192 9.73867 16.0427L6.15467 12.4587C5.84533 12.1493 5.84533 11.6373 6.15467 11.328C6.464 11.0187 6.976 11.0187 7.28534 11.328L10.304 14.3467L16.704 7.94667C17.0133 7.63733 17.5253 7.63733 17.8347 7.94667C18.144 8.256 18.144 8.768 17.8347 9.07733Z"
      fill="currentColor"
    />
  </svg>
))
